export const getGameImage = (
  type: "big" | "small",
  gameData?: { data: string; metadata?: string; id: string },
) => {
  const gameImages = JSON.parse(
    gameData?.metadata || gameData?.data || "null",
  )?.gameImages;
  const supportConfig = JSON.parse(import.meta.env.VITE_SUPPORT_CFG);
  const imageUrl = `${supportConfig?.cms?.cdnPath}assets/games_v2/${gameData?.id}`;

  if (gameImages?.[type]?.startsWith("http")) {
    return {
      png: gameImages?.[type],
      webp: gameImages?.[type],
      png2x: gameImages?.[`${type}2x`],
      webp2x: gameImages?.[`${type}2x`],
      png3x: gameImages?.[`${type}3x`],
      webp3x: gameImages?.[`${type}3x`],
    };
  }
  return {
    png: gameImages?.[type]
      ? imageUrl + `/${gameImages?.[type]}.png`
      : undefined,
    webp: gameImages?.[type]
      ? imageUrl + `/${gameImages?.[type]}.webp`
      : undefined,
    png2x: gameImages?.[`${type}2x`]
      ? imageUrl + `/${gameImages?.[`${type}2x`]}.png`
      : undefined,
    webp2x: gameImages?.[`${type}2x`]
      ? imageUrl + `/${gameImages?.[`${type}2x`]}.webp`
      : undefined,
    png3x: gameImages?.[`${type}3x`]
      ? imageUrl + `/${gameImages?.[`${type}3x`]}.png`
      : undefined,
    webp3x: gameImages?.[`${type}3x`]
      ? imageUrl + `/${gameImages?.[`${type}3x`]}.webp`
      : undefined,
  };
};
